import React from 'react';
import { BenefitType } from '../types/benefit';

interface BenefitProps {
  benefit?: BenefitType;
}

const Benefit: React.FC<BenefitProps> = ({ benefit }) => {
  return (
    <div className="ceas-flex">
      <div className="ceas-mb-4 ceas-flex-shrink-0 ceas-mr-4">
        {benefit?.vendor?.merchant_data?.merchant_gravatar && (
          <div className="ceas-h-16 ceas-w-16 ceas-border ceas-border-gray-300 ceas-over-flow-hidden">
            <img
            src={benefit?.vendor?.merchant_data?.merchant_gravatar}
            alt="benefit image"
            className="ceas-object-cover ceas-h-16"
          />
          </div>
        )}
      </div>
      <div>
        <h4 className="ceas-text-lg ceas-font-bold">{benefit?.name}</h4>
        {benefit?.level.length && (
          <p className="ceas-mt-1 ceas-text-sm ceas-text-gray-500">({benefit?.level.join(', ')})</p>
        )}
        {benefit?.vendor && (
          <p className="ceas-mt-1">{benefit?.vendor?.merchant_data?.store_name}</p>
        )}
      </div>
    </div>
  );
};

export default Benefit;
